import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: string | Date) {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(date))
}

export function formatRelativeDate(date: string | Date) {
  const now = new Date()
  const d = new Date(date)
  const diffMs = now.getTime() - d.getTime()
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))
  if (diffDays === 0) return 'Today'
  if (diffDays === 1) return 'Yesterday'
  if (diffDays < 7) return `${diffDays}d ago`
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`
  return formatDate(date)
}

export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const PLATFORM_COLORS: Record<string, string> = {
  linkedin:    '#0A66C2',
  indeed:      '#003A9B',
  glassdoor:   '#0CAA41',
  monster:     '#6E0AC9',
  ziprecruiter:'#FF6D00',
  builtin:     '#10B981',
}

export const PLATFORM_BG: Record<string, string> = {
  linkedin:    'bg-blue-100 text-blue-700',
  indeed:      'bg-indigo-100 text-indigo-700',
  glassdoor:   'bg-green-100 text-green-700',
  monster:     'bg-purple-100 text-purple-700',
  ziprecruiter:'bg-orange-100 text-orange-700',
  builtin:     'bg-emerald-100 text-emerald-700',
}

export const STATUS_COLORS: Record<string, string> = {
  applied:   'bg-[#a3e635]/10 text-[#a3e635] border-[#a3e635]/20',
  pending:   'bg-amber-500/10 text-amber-400 border-amber-500/20',
  interview: 'bg-[#38bdf8]/10 text-[#38bdf8] border-[#38bdf8]/20',
  rejected:  'bg-red-500/10 text-red-400 border-red-500/20',
  offer:     'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
}
